import React from "react";
import { Outlet, useParams } from "react-router-dom";
import StudentApplications from "./StudentApplications";
import CompanyApplications from "./CompanyApplications";

const Applications = () => {
  const { applicationId } = useParams(); // Get applicationId from the URL
  const userRole = localStorage.getItem("userRole"); // Retrieve userRole from localStorage

  // If applicationId exists, render the Outlet (for nested routes)
  if (applicationId) {
    return <Outlet />;
  }

  // If userRole is not present, show a login prompt
  if (!userRole) {
    return <div>Please log in to view this page.</div>;
  }

  // Conditional rendering based on userRole
  if (userRole === "student") {
    return <StudentApplications />;
  } else if (userRole === "organization") {
    return <CompanyApplications />;
  } else {
    return <div>Unauthorized: Access denied for this user role.</div>;
  }
};

export default Applications;
